import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path d="M21 2c-.6 0-1 .4-1 1v6h-1.1c-.5-2.3-2.5-4-4.9-4H7c-2.8 0-5 2.2-5 5 0 1.8 1 3.6 2.4 4.6.6.4 1.2.6 1.9.6.4 0 .8-.1 1.2-.2.3-.1.7-.3 1.5-1.2.9-.9 2.5-.9 3.3 0 .8.8 1.2 1.1 1.5 1.2 1 .4 2.1.3 3-.4 1.1-.8 2-2.1 2.2-3.6h1v5c0 2.2-1.8 4-4 4h-3c-.8 0-1.2-.5-1.3-1h.3c.6 0 1-.4 1-1s-.4-1-1-1H9c-.6 0-1 .4-1 1s.4 1 1 1h.6c.3 1.8 1.6 3 3.4 3h3c3.3 0 6-2.7 6-6V3c0-.6-.4-1-1-1zm-5.5 10.9c-.6.4-1 .2-1.1.2 0 0-.2-.1-.8-.7a4.1 4.1 0 00-3.1-1.4c-1.2 0-2.3.5-3.1 1.4-.5.6-.8.7-.8.7-.1.1-.6.2-1.2-.2C4.6 12.4 4 11.1 4 10c0-1.7 1.3-3 3-3h7c1.7 0 3 1.3 3 3 0 1.1-.6 2.4-1.5 2.9z" />,
  'Diving'
)
